<form class="wrapper">
    @for (option of options; track option) {
    <label class="label" [style.--control-diameter]="cssVariableValue(option)">
        <input
            class="input"
            type="radio"
            [value]="option"
            [checked]="option === value"
            name="controlDiameter[]"
            (change)="onChange(option)"
        />
        <div class="item">
            <div class="circle"></div>
        </div>
    </label>
    }
</form>
